export const FOOTER_LINKS = [
    {
      title: 'Bold',
      links: [
        'apropos',
        'programme',
        'blogue',
      ],
    },
    {
        title: 'En Plus',
        links: [
          'don',
          'contact',
          ''
        ],
      }
  ];
  
  export const FOOTER_CONTACT_INFO = {
    title: 'Contact Us',
    links: [
      { label: 'Admin Officer', value: '+243 974 970 837' },
      { label: 'Email Officer', value: 'bold@Info.com' },
    ],
  };
  
  export const SOCIALS = {
    title: 'Social',
    links: [
      '../data/facebook.svg',
      '../data/instagram.svg',
      '../data/twitter.svg',
      '../data/youtube.svg',
      '../data/wordpress.svg',
    ],
  };